import { render, staticRenderFns } from "./DoorPlanetsIcon.vue?vue&type=template&id=511c36df"
import script from "./DoorPlanetsIcon.vue?vue&type=script&lang=js"
export * from "./DoorPlanetsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports